import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class FieldDashboardDataService {
  private fieldDataSubject = new BehaviorSubject<any>({
    fieldName: '',
    numberOfFields: 0,
    totalHectares: 0,
    country: '',
    fieldId: '',
    farmId: '',
    farmName: '',
    tenantId: '',
    boundaryPoints: [],
    startDate: null,
    endDate: null
  });

  fieldData$ = this.fieldDataSubject.asObservable();

  updateFieldData(data: any): void {
    const currentData = this.fieldDataSubject.value;
    const updatedData = { ...currentData, ...data };

    if (data.fieldId && data.fieldId !== currentData.fieldId) {
      updatedData.boundaryPoints = [];
    }
    
    this.fieldDataSubject.next(updatedData);
  }

  getFieldData(): any {
    return this.fieldDataSubject.value;
  }
}
